/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarElement\CarElement3.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday February 9th 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Tuesday, 27th August 2024 12:21:29
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState } from "react";
import CarInfo from "Content/Car/CarInfo/CarInfo";
import { useLoaderData } from "react-router-dom";
import CarSingleCarousel from "Content/Car/CarSingleCarousel/CarSingleCarousel";
import styles from "Content/Car/CarElement/CarElement.module.css";
import CarCardHeader from "Content/Car/CarCardHeader/CarCardHeader";
import CarEquipment from "Content/Car/CarEquipment/CarEquipment";
import translator from "MultiLanguage/TranslationWrapper";
import HolderStyled from "Theme/Component/HolderStyled";
import { useMyContext } from "Content/Main/Main";
import CarService from "Services/Cars/CarService";
import { SingleCarFormat } from "Content/Car/CarElement/CarElement.type";
import PricingHolder from "Content/Car/Pricing/Slider/PricingHolder";
import { useAuth } from "Router/AuthProvider";
import CarCostOffline from "Content/Car/CarCostOffline/CarCostOffline";

function CarElement() {
    const singleCar: SingleCarFormat = useLoaderData() as SingleCarFormat;
    const [carImg, setCarImg] = useState([]);
    const [carEquipment, setCarEquipment] = useState([]);
    const themeColor: string = singleCar.iconSubSection.IconSubSection;
    const { setterThemeColor } = useMyContext();
    const { isConnected } = useAuth();

    useEffect(()=>{
        setterThemeColor(themeColor);
    }, []);

    useEffect(() => {
        CarService.getPicturesForOneCar(singleCar.id).then((val: {data: []}) => setCarImg(val.data)).catch((error) => console.error(error));
        CarService.getEquipementsForOneCar(singleCar.id).then((val: {data: []}) => {setCarEquipment(val.data)}).catch((error) => console.error(error));
    }, []);

    return (
        <div className={`${styles.carElementContainer}`}>
            <div className={`${styles.widthCarou}`}>
                <HolderStyled bgColor={themeColor} className={`${styles.carElementContainerLeft}`}>
                    <div>
                        <CarCardHeader IconSubSection={singleCar.iconSubSection.IconSubSection} themeColor={themeColor} />
                        <CarSingleCarousel pictureObjects={carImg} themeColor={themeColor} />
                    </div>
                    <div className={`${styles.carInfoPhone}`}>
                        <CarInfo Brand={singleCar.carInfo.Brand} Model={singleCar.carInfo.Model} Version={singleCar.carInfo.Version}
                        Energy={singleCar.carInfo.Energy} Gears={singleCar.carInfo.Gears} CirculationDate={singleCar.carInfo.CirculationDate}
                        Mileage={singleCar.carInfo.Mileage} Color={singleCar.carInfo.Color} Nb_Col={2} Nb_Elem={8} Car_Type={singleCar.carInfo.CarType.Name} themeColor={themeColor} Link={singleCar.carInfo.Link ?? ""} />
                    </div>
                </HolderStyled>
                <HolderStyled bgColor={themeColor} className={`${styles.carEquipmentHolder}`}>
                    <h2 className={"titleEquipment"}>{translator.decode("categories.comments").toUpperCase()}</h2>
                    {
                        ["", undefined, null].includes(singleCar.carInfo.Comments) ?
                            <p className="fst-italic">{translator.decode("categories.noComments")}</p>
                            :
                            <p>{singleCar.carInfo.Comments}</p>
                    }
                </HolderStyled>
                {
                    carEquipment.length !== 0 ?
                    <HolderStyled bgColor={themeColor} className={`${styles.carEquipmentHolder}`}>
                        <h2 className={"titleEquipment"}>{translator.decode("categories.equipments").toUpperCase()}</h2>
                        <CarEquipment Equipment={carEquipment} themeColor={themeColor}/>
                    </HolderStyled>
                    :null
                }
            </div>
            <div className={`${styles.carElementContainerRight}`}>
                <HolderStyled bgColor={themeColor} className={`${styles.boxRight}`} >
                    {
                        isConnected ?
                            <div className={`${styles.separatingLineHolder}`}>
                                <PricingHolder id={singleCar.id} themeColor={themeColor} brand={singleCar.carInfo.Brand} />
                            </div>
                        :
                            <CarCostOffline customText={singleCar.carCost.CustomText} themeColor={themeColor} />
                    }
                </HolderStyled>
            </div>
        </div>
    );
}

export default CarElement;
